<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">Экспорт акта комиссионного обследования</span>
      <a class="close" @click="$emit('close')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#0033A0"/>
        </svg>
      </a>
    </v-card-title>

    <v-card-text>
      <div class="rating-popup">
        <v-container>
          <v-row>
            <v-col cols="12">
              <h4>Формат</h4>
              <v-radio-group v-model="exportType" row>
                <v-radio label="XLSX" value="xlsx"></v-radio>
                <v-radio label="PDF" value="pdf"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
          text
          outlined
          class="export-button"
          @click="$emit('close')"
      >
        Закрыть
      </v-btn>
      <v-btn
          class="export-button"
          @click="download()"
      >
        Скачать
      </v-btn>
    </v-card-actions>
    <LoaderDialog :show="loading" msg="Загрузка"></LoaderDialog>
  </v-card>
</template>

<script>
import api from "@/modules/api";
import LoaderDialog from "@/components/elements/LoaderDialog.vue";

export default {
  name: 'StandardExportDialog',
  components: {LoaderDialog},
  props: {
    act: null,
    config: null,
  },
  data: () => ({
    exportType: "xlsx",
    domain: 'standard_act',
    loading: false,
    downloadTaskId: null,
  }),
  methods: {
    async download() {
      try {
        this.loading = true
        const queryString = new URLSearchParams({
          indicator_form_id: this.act.id,
          config_id: this.config.id,
          format: this.exportType,
        });

        const response = (await api.get(`/reports/generate/${this.domain}/1?${queryString}`)).payload
        this.downloadTaskId = response.task_id
        await this.checkTaskStatus()
      } catch (error) {
        console.error('Error generating report:', error)
        alert('Ошибка при генерации отчета!');
        this.loading = false;
      }
    },
    async checkTaskStatus() {
      try {
        const response = (await api.get(`/reports/status/${this.downloadTaskId}`)).payload
        if (response.status === 'SUCCESS') {
          await this.downloadFile()
        } else {
          setTimeout(this.checkTaskStatus, 2000)
        }
      } catch (error) {
        console.error('Error checking task status:', error)
        alert('Ошибка при проверке статуса задачи!')
        this.loading = false
      }
    },
    async downloadFile() {
      try {
        const blob = (await api.get(`/reports/download/${this.downloadTaskId}`, null, 'blob')).payload
        await this.$downloadBlob(blob, `Акт комиссионного обследования.${this.exportType}`)
      } catch (error) {
        console.error('Error downloading file:', error)
        alert('Ошибка при скачивании файла!')
      } finally {
        this.$emit('close')
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.export-button {
  height: 45px !important;
  margin-bottom: 10px !important;
}
</style>
